import Menu from './Menu'
import './Menu.css'

export default Menu



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/containers/Menu/index.js